import Select from "react-select";
import styled from "styled-components";

import { Button, Icons } from "src/components";

export const Text = styled.p`
  padding: 0;
  margin: 0;
  font-size: 14px;
  line-height: 24px;
`;

export const TextArea = styled.textarea`
  position: relative;
  width: 100%;
  height: 114px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  font-size: 14px;
  color: black;
  padding: 8px;
`;

export const CommentWrapper = styled.label`
  position: relative;
  width: 100%;
`;

export const CommentLabel = styled.span`
  font-size: 12px;
  display: block;
  color: black;
  margin-top: 32px;
  margin-bottom: 16px;
`;

export const AddressButton = styled(Button)`
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  padding-left: 23px;
  border: none;
  background-color: transparent;

  position: relative;

  cursor: pointer;

  color: initial;
  text-decoration: none;
  text-transform: none;
  margin: 10px 0;
  &:hover {
    opacity: 0.5;
  }

  svg {
    margin-top: 7px;
  }
`;

export const PlusIcon = styled(Icons.Plus)`
  width: 18px;
  height: 18px;
  padding: 2px;
  border-radius: 50%;
  border: 1px solid ${({ theme }): string => theme.colors.black};

  position: absolute;
  left: 0;
  top: -2px;
`;

export const RadioGroupLabel = styled.p`
  font-family: "Formular";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  margin: 0;
  width: 100%;
  cursor: pointer;
  padding: 45px;
  background: rgba(250, 250, 250, 0.93);
  @media screen and (max-width: 768px) {
    padding: 25px;
  }
`;

export const InputWrapper = styled.div`
  padding: 0 45px;
  padding-bottom: 24px;
  margin-bottom: 15px;
  background: rgba(250, 250, 250, 0.93);
  display: flex;
  align-items: center;
  gap: 18px;

  @media screen and (max-width: 768px) {
    padding: 0 25px;
    padding-bottom: 24px;
    gap: 12px;
  }
`;

export const InputLabel = styled.p`
  font-family: "Formular";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  margin: 0;
  width: 100%;
  margin: 0 12px;
  background: rgba(250, 250, 250, 0.93);
  padding: 45px;

  @media screen and (max-width: 768px) {
    padding: 25px;
  }
`;

export const ResetInputButton = styled.button`
  background: transparent;
  border: 0;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: max-content;
  margin: 0;
`;

export const ResetInputIcon = styled(Icons.Close)`
  width: 12px;
  height: 12px;
  cursor: pointer;
`;

export const MapWrapper = styled.div`
  height: 300px;
`;

export const CitySelect = styled(Select)`
  color: black;
  flex: 1;
  & > .field__control {
    border: none;
    border-bottom: 1px solid black !important;
    background: rgba(250, 250, 250, 1);
    border-radius: 0px;

    box-shadow: none;
    & > .field__indicators {
      display: none;
    }
  }
  & > .field__menu {
    border: 1px solid black !important;
    background: white;
    border-radius: 0px;

    box-shadow: none;
    & > .field__menu-list {
      & > .field__option {
        color: black;
        font-weight: 400;
      }
      & > .field__option--is-selected {
        font-weight: 500;
        background: white;
      }
      & > .field__option--is-focused {
        font-weight: 500;
        background: white;
      }
    }
  }
`;

export const PVZContainer = styled.div`
  padding: 0 45px;
  padding-bottom: 45px;
  margin-bottom: 15px;
  background: rgba(250, 250, 250, 0.93);
  display: flex;
  align-items: center;
  gap: 18px;
`;

export const PVZAddress = styled.p`
  font-size: 16px;
`;

export const EditAddressButton = styled.button`
  background: transparent;
  border: 0;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  height: max-content;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;
export const EditAddressIcon = styled(Icons.Edit)`
  width: 16px;
  height: 16px;
`;
